import { getKeyboardFocusableElements } from 'utils';

export const handlePageTabIndex = (modalOpens: boolean, element?: any) => {
  const pageElems = getKeyboardFocusableElements();

  for (let i = 0; i < pageElems.length; i++) {
    const newIndex = String(parseInt(pageElems[i].getAttribute('tabindex') || 0) + (modalOpens ? -10 : 10));
    pageElems[i].setAttribute('tabindex', newIndex);
  }

  if (modalOpens && element) {
    const dialogElems = getKeyboardFocusableElements(element);
    for (let i = 0; i < dialogElems.length; i++) {
      const newIndex = String(parseInt(dialogElems[i].getAttribute('tabindex') || 0) + 10);
      dialogElems[i].setAttribute('tabindex', newIndex);
    }
  }
};
